/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useEffect } from 'react';
import {useDispatch} from 'react-redux';
import {
    Navigate,
    Route,
    Routes
} from 'react-router-dom';
import {getMetaData} from '../common/metadata/metaDataSlice';

import AdminHomeRouter from './home/AdminHomeRouter.jsx';
import SourcesRouter from './sources/SourcesRouter.jsx';
import InputsRouter from './inputs/InputsRouter.jsx';
import OrganizationsRouter from "./organizations/OrganizationsRouter.jsx";
import AccountsRouter from "./accounts/AccountsRouter.jsx";
import AdminListsRouter from "./lists/AdminListsRouter";
import ManagedListErrorsRouter from "./list-errors/ManagedListErrorsRouter";
import ManagedListMatchesRouter from "./list-matches/ManagedListMatchesRouter";
import ManagedListMatchLogsRouter from "./list-match-logs/ManagedListMatchLogsRouter";
import ManagedMatchTemplatesRouter from "./match-templates/ManagedMatchTemplatesRouter";
import ManagedMatchTypesRouter from "./match-types/ManagedMatchTypesRouter";
import ContractorDirectoryRouter from "./contractor-directory/ContractorDirectoryRouter";
import ManagedIntegrationsRouter from "./integrations/ManagedIntegrationsRouter";
import EntityVerificationsRouter from "./entity-verifications/EntityVerificationsRouter";
import CompaniesRouter from "./companies/CompaniesRouter";
import ManagedEventsRouter from "./events/ManagedEventsRouter";

export default function AdminRouter() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getMetaData());
    }, [dispatch]);

    return (
        <Routes>
            <Route path="/admin/home/*" element={<AdminHomeRouter/>}/>
            <Route path="/admin/sources/*" element={<SourcesRouter/>}/>
            <Route path="/admin/inputs/*" element={<InputsRouter/>}/>
            <Route path="/admin/accounts/*" element={<AccountsRouter/>} />
            <Route path="/admin/integrations/*" element={<ManagedIntegrationsRouter/>} />
            <Route path="/admin/lists/*" element={<AdminListsRouter/>} />
            <Route path="/admin/list-errors/*" element={<ManagedListErrorsRouter/>} />
            <Route path="/admin/list-matches/*" element={<ManagedListMatchesRouter/>} />
            <Route path="/admin/list-match-logs/*" element={<ManagedListMatchLogsRouter/>} />
            <Route path="/admin/events/*" element={<ManagedEventsRouter/>} />
            <Route path="/admin/organizations/*" element={<OrganizationsRouter/>} />
            <Route path="/admin/tools/contractor-directory/*" element={<ContractorDirectoryRouter/>} />
            <Route path="/admin/match-templates/*" element={<ManagedMatchTemplatesRouter/>} />
            <Route path="/admin/match-types/*" element={<ManagedMatchTypesRouter/>} />
            <Route path="/admin/entity-verifications/*" element={<EntityVerificationsRouter/>} />
            <Route path="/admin/e/companies/*" element={<CompaniesRouter/>} />
            <Route path="/admin" element={<Navigate to="/admin/home" replace/>}/>
        </Routes>
    );
}
